module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-be.4d69eceb.png";